import BaseTable from "../BaseTable";
import CurrencyModal from "@/Modals/CurrencyManagement/Currencies/Modal";
import { HTTP_METHODS } from "@/constant/Http/methods";
import { IoMdSync } from "react-icons/io";
import RenderToast from "@/components/RenderToast";
import { activationStatusLabels } from "@/constant/Activation/status";
import { currencyRatesApi } from "@/apis/apis";
import { fxRateColumns } from "./FxRateColumns";
import { useCallback } from "react";
import { useGet } from "@/apiHooks/HttpFunctions";
import { useModalConfirmation } from "@/context/ModalConfirmationContext";
import { useModalInfo } from "@/context/ModalContext";

export default function FxRatesTable() {
  const { openModalConfirmation } = useModalConfirmation();
  const { openModalInfo } = useModalInfo();

  const refreshRateConfirmationModal = useCallback(() => {
    const refreshRatesApi = `${currencyRatesApi}/refresh`;
    openModalConfirmation({
      title: "This will immediately affect the prices shown on website.",
      customMutation: {
        confirmationMessage: "Are you sure you want to refresh rates manually?",
        apiURL: refreshRatesApi,
        action: HTTP_METHODS.PUT,
        onSuccess: () => {
          openModalInfo("Fx Rates refreshed successfully.");
        },
        onError: (error) => {
          RenderToast({
            type: "error",
            message:
              error.response.data.errors.error ?? "Something went wrong.",
          });
        },
      },
    });
  }, [openModalConfirmation, openModalInfo]);

  const { data: metaData } = useGet({
    apiURL: `${currencyRatesApi}/meta`,
  });
  let lastRefreshTime = "";
  let lastRefreshName = "";
  let lastRefreshStatus = "";
  let lastSuccessfulRefreshTime = "";
  let nextRefreshTime = "";
  let rateProvider = "";
  if (metaData) {
    const data = metaData?.data;
    lastRefreshTime = data?.last_refresh_rate?.fetched_at
      ? data.last_refresh_rate.fetched_at.split(" ").join(" | ")
      : null;
    lastRefreshName =
      data?.last_refresh_rate?.triggered_by_user?.first_name.concat(
        data?.last_refresh_rate?.triggered_by_user?.last_name ?? ""
      );
    const activationStatusLabelsMap = activationStatusLabels();
    lastRefreshStatus =
      activationStatusLabelsMap[data?.last_refresh_rate?.status];
    lastSuccessfulRefreshTime = data?.last_successful_refresh_rate?.fetched_at
      ? data?.last_successful_refresh_rate?.fetched_at.split(" ").join(" | ")
      : null;
    nextRefreshTime = data?.next_scheduled_refresh_rate
      ? data?.next_scheduled_refresh_rate.split(" ").join(" | ")
      : null;
    rateProvider = data?.rate_provider.replace("https://", "");
  }

  return (
    <>
      {metaData && (
        <div className="mb-2 text-sm text-gray-400">
          <div className="italic mb-2">FX Rates delivered by '{rateProvider}'</div>
          <div>
            Last Jersium refresh rates attempt: {lastRefreshTime ? `${lastRefreshTime} UTC by ${lastRefreshName} - ${lastRefreshStatus}` : "-"}
          </div>
          <div>Last successful rates update: {lastSuccessfulRefreshTime ? `${lastSuccessfulRefreshTime} UTC` : "-"}</div>
          <div>Next Jersium refresh rates scheduled: {nextRefreshTime ? `${nextRefreshTime} UTC` : "-"}</div>
        </div>
      )}
      <BaseTable
        label="Fx Rate"
        apiURL={currencyRatesApi}
        columns={fxRateColumns()}
        ModalComponent={CurrencyModal}
        importData={null}
        enableExport={false}
        enableStatus={false}
        enableActions={false}
        enableAdd={false}
        enableSearch={false}
        enableFilter={false}
        isFullPageTable={false}
        enablePagination={false}
        customHeaderActionsData={[
          {
            label: "Refresh Rates Now",
            onClick: refreshRateConfirmationModal,
            icon: IoMdSync,
            backgroundColor: "golden-gradient",
          },
        ]}
      />
    </>
  );
}
